module.exports = __webpack_public_path__ + "img/entry6.98282ab6.png";